module.exports = __webpack_public_path__ + "img/holiday-inn-lisbon-continental.11202e15.jpg";